

import Project from '../../pages/projects/Project'
export default function Projects() {
  return (
    <div className='projects'>
     <Project/>
    </div>
  )
}

